import axios from "axios";

const API = "/api";

const cabecalho = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const get = (caminho, { inicio, fim }) =>
  axios.get(`${API}${caminho}`, { headers: cabecalho(), params: { data_inicio: inicio, data_fim: fim } }).then((r) => r.data);

// Uma busca por aba: cada uma só carrega quando é aberta.
export const buscarResumo = (periodo) => get("/relatorios/tempo/resumo", periodo);
export const buscarMesas = (periodo) => get("/relatorios/tempo/mesas", periodo);
export const buscarComandas = (periodo) => get("/relatorios/tempo/comandas", periodo);
export const buscarEntregas = (canal) => (periodo) => get(`/relatorios/tempo/entregas/${canal}`, periodo);
